export enum SubStepActionEnum {
  CONTINUE = "CONTINUE",
  BACK = "BACK",
}
